import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(({ palette }) => ({
  appBar: {
    backgroundColor: colors.white,
    height: 70,
    alignItems: "center",
    flexDirection: "row",
    flexGrow: 1,
    margin: 0,
    padding: "15px 45px 15px 232px",
    left: 0,
    boxShadow: `0px 5px 5px ${palette.grey[300]}`,
  },
}));

export default useStyles;
